import { useState } from 'react';
import { Link } from 'react-router-dom';

type Section = { title: string; paragraphs: string[] };

const operator = '广州和晟网络科技有限公司';
const updated = '2026 年 10 月 19 日';
const contactChannel =
  '隐私权利申请、投诉和政策咨询，请联系 company@yingbaba.com；请勿通过普通邮件发送身份证件等敏感材料。';

const terms: Section[] = [
  {
    title: '一、平台与适用范围',
    paragraphs: [
      `影爸爸由${operator}运营。本条款适用于影爸爸网站、微信小程序、工作台及与之配套的平台服务。平台连接有影像制作需求的客户、影视制作服务商与影视资源提供方，并提供信息展示、合作联系、项目协作、创作与推广工具。制作服务和非数字影视资源的交易由合作双方自主安排；数字资源授权和付费会员适用各自专项规则。`,
      '注册、访问或使用平台前，请阅读本条款及隐私政策。涉及费用、支付、知识产权及责任的具体约定，以交易双方确认的订单、合同和适用的专项规则为准；如与本条款不一致，具体交易文件就该交易事项优先。',
    ],
  },
  {
    title: '二、账号、组织与入驻',
    paragraphs: [
      '注册人应提供真实、准确的信息，妥善保管账号和密码，并确保其有权代表所加入的组织操作。一个账号可加入多个组织；组织管理员应审慎分配成员权限，及时移除不再获授权的成员。',
      '服务商、资源方可以提交企业介绍、案例和资质材料。平台可核验资料并决定是否展示认证或公开内容；审核通过不代表平台对其服务质量、履约能力或资料真实性作出保证。资料发生变化时应及时更新。',
      '组织所有者可向有效成员发起交接，双方重新验证身份并确认后生效。账号注销及组织停用、删除须先处理未结合作、资金与争议。注销和删除的等待时间以申请页面为准，等待期内可按页面指引撤回；停用不消除既有责任，删除也不影响依法保存的交易与协作证据。',
    ],
  },
  {
    title: '三、需求、报价与项目合作',
    paragraphs: [
      '客户应尽量准确说明用途、预算、交付时间、素材权利及特殊拍摄要求。服务商和资源方应根据自身能力提供真实的方案、报价、档期和服务范围。禁止发布违法、侵权、虚假或误导性内容。',
      '需求、任务、会议纪要、文件版本和沟通记录可用于协作与留痕。双方应就实际服务范围、验收标准、修改次数、费用、档期和责任分配形成明确约定。平台提供记录工具，不自动成为客户与服务商之间的影视制作合同当事人。',
    ],
  },
  {
    title: '四、合作交易与平台收费服务',
    paragraphs: [
      '影视制作服务及非数字影视资源的报价、合同、付款、回款、交付、验收和争议处理，由合作双方自行约定和实施。影爸爸当前不提供这些合作的询价成交、平台订单、价款代收代付、分账、退款或验收操作，项目归档及任务完成不代表交易完成、验收通过或款项结清。',
      '数字资源授权与付费会员是独立的平台服务。提供收费服务时，将在实际购买页面展示价格、许可或服务内容、开通条件及退款规则，并遵循相应专项规则；不以影视制作项目中的任务或文件状态推定用户购买这些服务。',
    ],
  },
  {
    title: '五、内容、文件与知识产权',
    paragraphs: [
      '上传方应保证对其文字、图片、视频、音乐、肖像、商标及其他素材拥有必要权利，并已取得拍摄、使用和公开展示所需授权。上传方保有其依法享有的权利，并授权平台在提供服务、展示经其选择公开的内容及处理争议所必需范围内使用相关内容。',
      '项目文件及其历史版本按当前组织和项目访问权限向有权人员提供。将本组织素材引入另一项目时，上传方须确认有权向目标项目成员共享；引用固定的文件版本，源文件后续更新不会自动替换已引入版本。公开案例须由发布方提交并经平台审核。最终作品及原始素材的著作权、使用范围和交付形式，由交易双方另行明确约定。未经授权，其他用户不得复制或商用他人内容。',
    ],
  },
  {
    title: '六、AI、会议及第三方服务',
    paragraphs: [
      'AI 创作可辅助整理拍摄需求、生成脚本、分镜、营销文案和会议行动项。结构化需求及行动项仍需人工核对，行动项只有经用户确认后才创建项目任务，不自动变更订单或合同。生成结果可能不准确或涉及第三方权益，使用者应在对外发布、商业使用前自行核查事实、版权及合规性。具体 AI 服务的提供方和数据处理方式见隐私政策及功能页面提示。',
      '会议功能可记录腾讯会议、飞书会议等第三方会议链接与纪要。进入第三方服务后，还应遵守其规则；平台不提供自建视频通话。推广功能可记录用户维护的发布账号档案、素材版本和真实作品链接；保存账号档案不等于第三方平台授权，当前由用户自行在目标平台发布，不接收第三方平台密码或私有登录 Cookie。支付、会议等第三方服务发生故障时，平台会在其控制范围内协助排查。',
    ],
  },
  {
    title: '七、平台管理与服务变更',
    paragraphs: [
      '对涉嫌违法、侵权、虚假交易或危及平台安全的内容和账号，平台可在核实后采取限制展示、下架、暂停部分功能等与风险相称的措施，并提供申诉或说明机会；依法需要立即处置的情况除外。',
      '平台会维护服务的稳定性，但系统维护、网络故障或第三方服务异常可能造成暂时中断。对本条款或重要交易规则的重大调整，平台将按适用法律提前公示；已确认交易的价款与主要履约约定不因条款更新自动改变。',
    ],
  },
  {
    title: '八、争议与联系',
    paragraphs: [
      '交易双方应先依据订单、合同和平台协作记录沟通解决争议。对平台服务的投诉或规则异议，可通过本页公布的联系渠道提出；平台将核查并回复。协商不成的，依法向有管辖权的人民法院提起诉讼。',
      `平台运营主体：${operator}。对外联系渠道见本页末尾。`,
    ],
  },
];

const privacy: Section[] = [
  {
    title: '一、谁在处理你的信息',
    paragraphs: [
      `${operator}是影爸爸平台个人信息处理者。本政策说明我们在网站、微信小程序、工作台和管理后台提供服务时如何处理个人信息，以及你可以如何行使权利。第三方支付、会议或 AI 服务商对其独立处理的信息，可能另有隐私规则。`,
    ],
  },
  {
    title: '二、收集的信息与用途',
    paragraphs: [
      '创建账号时，我们处理姓名、电子邮箱、密码哈希值、组织名称及业务身份，用于建立账号、登录和组织协作。你发布资料时，我们处理企业介绍、联系人、案例、需求、报价、作品、项目文件、会议纪要及沟通记录，用于展示、撮合、履约与争议处理。请勿上传与项目无关的敏感个人信息。',
      '使用数字资源或会员收费服务，以及处理既有交易记录时，我们按所使用的服务处理订单、渠道交易号、付款凭证、退款与结算记录，用于交易核验、对账、客户支持及依法留存。当前影视制作和非数字资源合作不通过平台收付价款。我们还处理登录时间、设备和网络日志、操作记录，用于账号安全、异常排查和审计。',
      '你可以在小程序内主动授权绑定微信验证的手机号。取得你的同意后，我们通过微信接口核验授权凭证及其所属微信身份，将号码加密保存为账号手机号，并保存验证来源、验证时间及用于唯一识别号码的受保护索引，用于账号身份验证及必要的业务联系。页面仅显示脱敏号码，不公开展示；每个手机号只能绑定一个影爸爸账号，不会据此自动合并账号。短信验证码登录尚未开放，开放后你仍需完成验证码及账号要求的其他安全验证，不会仅凭知道手机号登录或重置密码。你可以在“我的”页面更换或解绑，操作需重新验证当前微信身份；解绑后删除当前保存的号码及其识别索引。微信手机号授权受微信接口开通状态限制，拒绝授权不影响现有邮箱、微信登录及其他服务。',
      '网站开通微信扫码登录后，我们处理微信网站应用或服务号内的用户标识（OpenID），用于验证微信身份并关联影爸爸账号。服务号方式还记录关注、取消关注状态及事件时间，用于维护公众号关系和扫码确认。临时登录记录包含浏览器类别、识别码和授权状态，用于核对设备、防止他人扫码登录。首次扫码需验证现有账号或自行注册后绑定；不会仅凭昵称、手机号或跨应用标识自动合并账号。关注、扫码不会直接建立登录会话；你需明确确认，并可拒绝或在账号设置中解除绑定。取消关注可在微信中操作。未来如开放服务通知，将另行说明用途并按微信规则取得必要授权，不将关注视为接受营销消息的同意。微信页面适用其隐私规则。',
      '使用微信小程序时，我们通过微信登录凭证获取用于账号绑定的用户标识（OpenID，以及微信返回时的 UnionID），将其与影爸爸账号关联，用于登录和小程序付款。登录会话保存在小程序本地存储，退出登录会清理本地会话。仅在你主动选择并上传照片、视频、文件或认证材料时，我们接收所选内容，用于项目协作、素材管理或认证审核；不会自动读取整个相册或其他未选择的文件。',
      '业务身份、组织选择等偏好可能保存在当前浏览器；登录会话使用 Cookie。浏览器偏好可通过清理站点数据删除，但删除后可能需要重新选择组织或工作台视角。',
    ],
  },
  {
    title: '三、展示、共享与第三方处理',
    paragraphs: [
      '经你主动发布并通过审核的服务商资料、案例、资源和需求，可向平台访问者公开。非公开项目资料按组织、项目成员和平台运营岗位的权限展示；与你合作的另一方可看到履约所需的信息。请在发布前核对是否包含不应公开的联系人或第三方信息。',
      '发起线上支付时，我们将完成交易所需的订单号、金额、商户及支付状态提供给所选支付机构，包括实际选用的微信支付、支付宝或银联渠道；处理退款和对账时也会交换必要的交易信息。使用腾讯会议、飞书会议链接时，离开平台后的信息处理适用其服务规则。',
      '使用 AI 创作并选择真实模型时，输入的提示词及为生成结果所需的上下文会发送至管理员配置的模型服务商。目前可配置的服务商包括 SiliconFlow、OpenRouter、Groq、Gemini 和 GLM；实际路由可能在失败时切换到其他模型，其中部分服务商可能位于境外。请勿在提示词中提交身份证件、银行账户、未获授权的客户素材等个人或敏感信息。模板模式不调用外部模型。',
      '我们不会出售个人信息。依法需要向监管或司法机关提供信息时，会在法定范围内处理。涉及向境外提供个人信息的情形，我们将按法律要求单独告知相关处理信息并履行必要程序；未经这些程序，不应在 AI 输入中提交个人信息。',
    ],
  },
  {
    title: '四、保存期限与安全',
    paragraphs: [
      '账号信息在账号存续期间保存。平台内经营者身份资料自其退出平台之日起、服务信息及交易信息自交易完成之日起，依法至少保存三年；会计资料等依法需要更长时间保存的，按相应法定期限执行。其他个人信息按完成具体服务、处理未结项目和争议所必要的最短期限确定。',
      '账号注销生效后，登录凭证、微信及手机号绑定会被清理，个人资料删除或去标识处理。组织删除分阶段进行：先停止公开展示并清理公开资料，非交易私有资料按适用留存期限和保全状态处理。未确定期限或尚有保全义务的资料保持受限保存，不向公众展示；共享项目文件、合同、资金及争议证据按各自适用规则保存，不因一方删除组织而从另一方记录中消失。备份依照备份保留规则到期清理，恢复备份时须重新执行已生效的删除处理。',
      '保存期限届满，或你依法要求删除且不存在继续保存的法定理由时，我们将删除或匿名化处理相关信息。法定保存期限尚未届满，或者删除、匿名化在技术上暂时难以实现的，我们将停止除存储和必要安全保护措施之外的处理。',
      '我们采取访问权限控制、密码摘要、加密传输、日志与备份等措施保护信息。互联网传输和系统运行无法保证绝对安全；发现可能影响你权益的安全事件时，我们会按法律要求采取补救措施并通知。',
    ],
  },
  {
    title: '五、你的权利',
    paragraphs: [
      '你可以在工作台「账号设置」或小程序「我的 → 账号注销」申请注销账号，在申请页面查看处理条件、时间并于等待期内撤回。组织所有者可在「组织管理」管理交接、停用及删除申请。你也可以通过本页公布的联系渠道申请查阅、复制、更正、补充、删除或限制处理个人信息，依法请求转移个人信息，撤回可撤回的同意，或要求解释处理规则。为保护账号安全，敏感操作需要重新核验身份。',
      '撤回同意不影响此前基于同意已经进行的处理；删除或注销请求可能受到未完成交易、争议处理及法定留存义务限制。我们会在法定期限内答复，并说明不能立即处理的原因。',
    ],
  },
  {
    title: '六、未成年人及政策更新',
    paragraphs: [
      '平台面向企业及专业影视从业者，不以未成年人为服务对象。若发现未经监护人同意处理了未成年人信息，请通过联系渠道告知，我们将核实并依法处理。',
      '因服务、法律或处理方式发生重要变化，我们会更新本政策并通过网站公示；涉及依法需要另行同意的处理，不以公示替代同意。',
    ],
  },
  {
    title: '七、联系与投诉',
    paragraphs: [
      `个人信息处理者：${operator}。隐私权利申请、投诉和政策咨询可通过本页末尾公布的渠道提出。`,
    ],
  },
];

export function LegalPage({ kind }: { kind: 'terms' | 'privacy' }) {
  const [query, setQuery] = useState('');
  const isTerms = kind === 'terms';
  const sections = isTerms ? terms : privacy;
  const search = query.trim().toLocaleLowerCase();
  const matches = search
    ? sections.flatMap((section, index) => {
        const paragraph = section.paragraphs.find((item) =>
          item.toLocaleLowerCase().includes(search),
        );
        if (!section.title.toLocaleLowerCase().includes(search) && !paragraph) return [];
        const offset = paragraph?.toLocaleLowerCase().indexOf(search) ?? -1;
        const start = Math.max(0, offset - 38);
        const end = Math.min(paragraph?.length ?? 0, offset + 76);
        const snippet = paragraph
          ? `${start ? '…' : ''}${paragraph.slice(start, end)}${end < paragraph.length ? '…' : ''}`
          : '';
        return [{ section, index, snippet }];
      })
    : [];
  function download() {
    const title = isTerms ? '影爸爸平台服务条款' : '影爸爸隐私政策';
    const content = [
      title,
      `更新日期：${updated}`,
      `运营主体：${operator}`,
      ...sections.flatMap((section) => [section.title, ...section.paragraphs]),
      '联系平台',
      `运营主体：${operator}`,
      contactChannel,
    ].join('\n\n');
    const url = URL.createObjectURL(new Blob([content], { type: 'text/plain;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = `${title}-20261003.txt`;
    link.click();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
  return (
    <article className="legal legal-document">
      <span className="eyebrow">YINGBABA · LEGAL</span>
      <h1>{isTerms ? '影爸爸平台服务条款' : '影爸爸隐私政策'}</h1>
      <p className="small muted">
        更新日期：{updated} · 运营主体：{operator}
      </p>
      <button type="button" className="link legal-download" onClick={download}>
        下载本文档
      </button>
      <p className="legal-lead">
        {isTerms
          ? '请在注册和使用影爸爸前阅读，了解平台服务范围、费用、内容使用及双方的权利与责任。'
          : '请在使用平台前阅读本政策，了解信息的收集、使用、共享和你的权利。'}
      </p>
      <div className="legal-search">
        <label htmlFor="legal-search-input">检索本文档</label>
        <input
          id="legal-search-input"
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder={isTerms ? '例如：费用、版权、争议' : '例如：AI、保存期限、删除'}
        />
        {search && (
          <div aria-live="polite" className="legal-search-results">
            <p>
              {matches.length
                ? `找到 ${matches.length} 个相关章节`
                : '没有找到相关章节，请尝试其他关键词。'}
            </p>
            {matches.length > 0 && (
              <ul>
                {matches.map(({ section, index, snippet }) => (
                  <li key={section.title}>
                    <a href={`#legal-section-${index + 1}`}>{section.title}</a>
                    {snippet && <span>{snippet}</span>}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
      <nav className="legal-toc" aria-label="文档目录">
        {sections.map((section, index) => (
          <a href={`#legal-section-${index + 1}`} key={section.title}>
            {section.title}
          </a>
        ))}
      </nav>
      {sections.map((section, index) => (
        <section className="legal-section" id={`legal-section-${index + 1}`} key={section.title}>
          <h2>{section.title}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </section>
      ))}
      <section className="legal-section" id="contact">
        <h2>联系平台</h2>
        <p>运营主体：{operator}</p>
        <p>{contactChannel}</p>
      </section>
      <p className="legal-related">
        {isTerms ? <Link to="/privacy">阅读隐私政策</Link> : <Link to="/terms">阅读服务条款</Link>}
        {' · '}
        <Link to="/">返回首页</Link>
      </p>
    </article>
  );
}
